<nav class="navbar">
    <div class="navbar__left">
        <div class="navbar__logo" routerLink="/dashboard">
            <svg width="197" height="33">
                <use [attr.href]="spritePath + '#' + icons['logo']"></use>
            </svg>
        </div>

        <div class="navbar__left-menu hidden nav:block">
            <ul class="navbar__menu">
                @for (item of menuItems; track item.label; let last = $last) {
                    @if (
                        !(item.label === 'Users' && isUsersOptionRestricted()) &&
                        !(item.label === 'Dealers' && isDealersOptionRestricted())
                    ) {
                        <li class="navbar__item" [class.navbar__item--active]="isRouteActive(item)">
                            <div class="navbar__content" (click)="setActive(item)">
                                @if (icons[item.iconKey]) {
                                    <svg class="navbar__icon" [attr.width]="14" [attr.height]="14">
                                        <use
                                            [attr.href]="
                                                spritePath + '#' + icons[item.iconKey]
                                            "></use>
                                    </svg>
                                } @else {
                                    <svg class="navbar__icon navbar__icon--placeholder">
                                        <use
                                            [attr.href]="
                                                spritePath + '#' + icons['profilePlaceholder']
                                            "></use>
                                    </svg>
                                }

                                <span class="navbar__label">{{ item.label }}</span>
                            </div>
                        </li>
                        @if (!last) {
                            <li class="navbar__item-separator"></li>
                        }
                    }
                }
            </ul>
        </div>
    </div>

    <div class="navbar__right">
        <!-- Desktop Profile -->
        <div class="hidden nav:flex items-center gap-4">
            <div
                #profileMenuRef
                class="navbar__profile"
                [class.navbar__profile--open]="showProfileDropdown"
                (click)="toggleProfileDropdown($event)"
                data-testid="navbar-profile-trigger">
                <div class="navbar__profile-avatar">
                    <span class="navbar__profile-avatar-initials">{{ userInitials() }}</span>
                </div>
                <div class="navbar__profile-meta">
                    <span class="navbar__profile-name">{{ userFullName() }}</span>
                    @if (userRoleName()) {
                        <span class="navbar__profile-role">{{ userRoleName() }}</span>
                    }
                </div>
                <svg
                    class="navbar__profile-chev"
                    [class.navbar__profile-chev--open]="showProfileDropdown"
                    width="14"
                    height="14">
                    <use [attr.href]="spritePath + '#' + icons['chevron']"></use>
                </svg>

                @if (showProfileDropdown) {
                    <div
                        class="navbar__profile-dropdown"
                        (click)="$event.stopPropagation()"
                        data-testid="navbar-profile-dropdown">
                        <div class="navbar__profile-dropdown-header">
                            <div class="navbar__profile-dropdown-avatar">
                                <span>{{ userInitials() }}</span>
                            </div>
                            <div class="navbar__profile-dropdown-identity">
                                <span class="navbar__profile-dropdown-name">{{
                                    userFullName()
                                }}</span>
                                @if (userEmail()) {
                                    <div class="navbar__profile-dropdown-email-row">
                                        <span
                                            class="navbar__profile-dropdown-email"
                                            [attr.title]="userEmail()"
                                            >{{ userEmail() }}</span
                                        >
                                        <button
                                            type="button"
                                            class="navbar__profile-dropdown-copy"
                                            [appCopy]="userEmail()"
                                            title="Copy email">
                                            <svg width="12" height="12">
                                                <use
                                                    [attr.href]="
                                                        spritePath + '#' + icons['copy']
                                                    "></use>
                                            </svg>
                                        </button>
                                    </div>
                                }
                                @if (userRoleName()) {
                                    <span class="navbar__profile-dropdown-role">{{
                                        userRoleName()
                                    }}</span>
                                }
                            </div>
                        </div>

                        <ul class="navbar__profile-dropdown-list">
                            @for (item of profileMenuItems; track item.action) {
                                <li
                                    class="navbar__profile-dropdown-item"
                                    [class.navbar__profile-dropdown-item--danger]="
                                        item.action === 'logout'
                                    "
                                    (click)="onProfileMenuItem(item.action)">
                                    @switch (item.action) {
                                        @case ('profileSettings') {
                                            <svg width="16" height="16">
                                                <use
                                                    [attr.href]="
                                                        spritePath + '#' + icons['settings']
                                                    "></use>
                                            </svg>
                                        }
                                        @case ('logout') {
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                <polyline points="16 17 21 12 16 7" />
                                                <line x1="21" y1="12" x2="9" y2="12" />
                                            </svg>
                                        }
                                    }
                                    <span>{{ item.label }}</span>
                                </li>
                            }
                        </ul>
                    </div>
                }
            </div>
        </div>

        <div class="flex nav:hidden items-center gap-2">
            <ntv-button
                class="navbar__mobile-toggle"
                [shadow]="false"
                color="custom"
                customColor="white"
                rounded="full"
                size="sm"
                (click)="toggleMenu()">
                <svg [attr.width]="24" [attr.height]="24">
                    <use
                        [attr.href]="
                            spritePath + '#' + (isMenuOpen ? icons['close'] : icons['menu'])
                        "></use>
                </svg>
            </ntv-button>
        </div>
    </div>

    <!-- Mobile Menu Overlay -->
    @if (isMenuOpen) {
        <div class="navbar__mobile-menu nav:hidden">
            <ul class="navbar__mobile-nav">
                @for (item of menuItems; track item.label) {
                    @if (
                        !(item.label === 'Users' && isUsersOptionRestricted()) &&
                        !(item.label === 'Dealers' && isDealersOptionRestricted())
                    ) {
                        <li class="navbar__mobile-item" [class.active]="isRouteActive(item)">
                            <div
                                class="navbar__mobile-item-content"
                                (click)="setActive(item); isMenuOpen = false">
                                <div class="flex items-center gap-3">
                                    @if (icons[item.iconKey]) {
                                        <svg
                                            class="navbar__icon"
                                            [attr.width]="18"
                                            [attr.height]="18">
                                            <use
                                                [attr.href]="
                                                    spritePath + '#' + icons[item.iconKey]
                                                "></use>
                                        </svg>
                                    }
                                    <span class="navbar__label">{{ item.label }}</span>
                                </div>
                            </div>
                        </li>
                    }
                }
            </ul>

            <!-- Mobile Profile Section -->
            <div class="navbar__mobile-profile" data-testid="navbar-mobile-profile">
                <div class="navbar__mobile-profile-header">
                    <div class="navbar__mobile-profile-avatar">
                        <span>{{ userInitials() }}</span>
                    </div>
                    <div class="navbar__mobile-profile-identity">
                        <span class="navbar__mobile-profile-name">{{ userFullName() }}</span>
                        @if (userEmail()) {
                            <div class="navbar__mobile-profile-email-row">
                                <span
                                    class="navbar__mobile-profile-email"
                                    [attr.title]="userEmail()"
                                    >{{ userEmail() }}</span
                                >
                                <button
                                    type="button"
                                    class="navbar__mobile-profile-copy"
                                    [appCopy]="userEmail()"
                                    title="Copy email">
                                    <svg width="12" height="12">
                                        <use [attr.href]="spritePath + '#' + icons['copy']"></use>
                                    </svg>
                                </button>
                            </div>
                        }
                        @if (userRoleName()) {
                            <span class="navbar__mobile-profile-role">{{ userRoleName() }}</span>
                        }
                    </div>
                </div>

                <ul class="navbar__mobile-profile-list">
                    @for (item of profileMenuItems; track item.action) {
                        <li
                            class="navbar__mobile-profile-item"
                            [class.navbar__mobile-profile-item--danger]="item.action === 'logout'"
                            (click)="onProfileMenuItem(item.action); isMenuOpen = false">
                            @switch (item.action) {
                                @case ('profileSettings') {
                                    <svg width="18" height="18">
                                        <use
                                            [attr.href]="
                                                spritePath + '#' + icons['settings']
                                            "></use>
                                    </svg>
                                }
                                @case ('logout') {
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                        <polyline points="16 17 21 12 16 7" />
                                        <line x1="21" y1="12" x2="9" y2="12" />
                                    </svg>
                                }
                            }
                            <span>{{ item.label }}</span>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
</nav>
